<template>
  <div >
    <Menu />
    <div ref="printContent">

      <div v-if="!loading">
        <div class="container-fluid bg-light pt-3 mb-3" v-if="ogListing != ''">
          <div class="row">
            <div class="col-md-12 text-center text-uppercase">
              <p v-if="ogListing[0].status != 'Active'"><strong>This property is no longer available</strong></p>
            </div>
          </div>
        </div>
      </div>

      <h1 style="display: none;">{{ listing.data.listing[0].marketing_heading }}</h1>
      <center><h2>For Rent</h2></center>

      <div class="container-fluid">
        <div class="row">
          
          <div class="col-12 text-center" v-if="listing.data.listing[0].id == 4203986">
            <a target=_blank href="/files/the-oceans-edge.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3121873">
            <a target=_blank href="/files/3121873.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3160115">
            <a target=_blank href="/files/3160115.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3125673">
            <a target=_blank href="/files/3125673.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

            <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3043973">
            <a target=_blank href="/files/3043973.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3140766">
            <a target=_blank href="/files/3140766.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

           <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2951950">
            <a target=_blank href="/files/2951950.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>
          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2951568">
            <a target=_blank href="/files/2951568.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>
          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2855719">
            <a target=_blank href="/files/2855719.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>
           <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3072078">
            <a target=_blank href="/files/3072078.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>
          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2579877">
            <a target=_blank href="/files/2579877.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>
          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2886916">
            <a target=_blank href="/files/2886916.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2836117">
            <a target=_blank href="/files/2836117.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2677942">
            <a target=_blank href="/files/2677942.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 3029715">
            <a target=_blank href="/files/3029715.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

           <div class="col-12 text-center" v-else-if="listing.data.listing[0].id == 2832950">
            <a target=_blank href="/files/mountain.pdf" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>

          <div class="col-12 text-center" v-else>
            <a target=_blank :href="'/brochure-rental/' + ogListing[0].id" class="btn btn-primary filter-btn" ><i class="bi bi-file-pdf-fill"></i> PDF VERSION</a>
          </div>
        </div>
      </div>

      <div style="z-index: 999; position: fixed; bottom: 0px; right: 0px; padding: 15px; background-color: #efefef; border-top-left-radius: 30px;" class="text-end">
        <a v-on:click="incrementLeads" id="whatsapp-agent-property" v-if="this.agent.first_name != null" target="_blank" style="font-size: 28px; text-decoration: none; color: #e00233 " :href="whatsappLink"><strong> <span style="font-size: 10px; line-height: 10px;">{{ agent.first_name }} &nbsp;</span><i class="bi bi-whatsapp"></i></strong></a><br/>
        <a v-on:click="incrementLeads" id="whatsapp-agent-property-2" v-if="this.agent_2.first_name != null" target="_blank" style="font-size: 28px; text-decoration: none; color: #e00233 " :href="whatsappLink_2"><strong> <span style="font-size: 10px;">{{ agent_2.first_name }} &nbsp;</span><i class="bi bi-whatsapp"></i></strong></a><br/>
        <a v-on:click="incrementLeads" id="whatsapp-agent-property-3" v-if="this.agent_3.first_name != null" target="_blank" style="font-size: 28px; text-decoration: none; color: #e00233 " :href="whatsappLink_3"><strong> <span style="font-size: 10px; line-height: 10px;">{{ agent_3.first_name }} &nbsp;</span><i class="bi bi-whatsapp"></i></strong></a>
      </div>

<button type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" class="btn" style="padding: 0px; border: none; background: transparent; width: 100%; height: auto; text-decoration: underline; color: #255699;"><i class="bi bi-images"></i> View Gallery</button>



      <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header">
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body px-3">
          <ContactForm />
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12 text-start">
            <p v-if="this.listing.data.listing[0].on_show && !loading"><strong>ON SHOW</strong> <span v-if="this.listing.data.listing[0].on_show_every_saturday">Saturdays</span> <span v-if="this.listing.data.listing[0].on_show_every_sunday">Sundays</span> <span> {{ listing.data.listing[0].on_show_start_time }}</span></p>
          </div>
        </div>
      </div>

      <section v-if="listing.template == 1 && !loading">
        
        <div id="banner" class="my-5">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="porfolio-banner">
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                      <img :src="listing.featured_image" class="mw-100" style="border-top-left-radius: 30px;" alt="Rental" />
                    </button>
                  <h1 class="text-md-start text-center p-2" style="background: rgba(255, 255, 255, 0.8); border-bottom-right-radius: 30px;">{{ listing.data.listing[0].marketing_heading }}<br/><br/>
                    <span>{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                    <strong v-if="listing.data.listing[0].poa !== true">R {{ formattedPrice }}</strong>
                    <strong v-if="listing.data.listing[0].poa === true">POA</strong>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
           <!-- Offcanvas component -->
          <div class="offcanvas offcanvas-bottom" id="offcanvasBottom" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">GALLERY VIEW</h5>
              <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div class="offcanvas-body">
            <!-- Gallery Start In Offcanvas -->
          <div class="photo-album">
              <!-- First Row: 2 Large Images -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[0]" data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[0]"class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[1]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[1]" class="img-fluid" style="height: 500px; border-radius: 0; padding-right: 14px;"/>
                      </a>
                  </div>
              </div>

              <!-- Second Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[2]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[2]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[3]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[3]"class="img-fluid" style="height: 420px; border-radius: 0;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[4]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[4]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Third Row: 1 Large Image -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[5]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[5]" class="img-fluid" style="height: 770px; border-radius: 0; padding-left: 14px;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Fourth Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[6]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[6]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[7]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[7]" class="img-fluid" style="height: 420px; border-radius: 0;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[8]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[8]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Fifth Row: 1 Large Image -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[9]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[9]" class="img-fluid" style="height: 770px; border-radius: 0;  padding-left: 14px;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Sixth Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[10]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[10]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[11]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[11]" class="img-fluid" style="height: 420px; border-radius: 0; " />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[12]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[12]" class="img-fluid" style="height: 420px; border-radius: 0; padding-right: 14px;" />
                    </a>
                  </div>
              </div>


              <!-- Eleventh Row: 2 Large Images -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[13]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[13]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[14]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[14]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>
          </div>
          </div>
          </div>

          <!-- End of Gallery in Offcanvas -->

        <div class="switch-bg-lblue pt-5">
          <div class="wrapper position-relative">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h5 class="switch-blue pt-3">Overview</h5>
                    <p>{{ listing.ai_description }}</p>
                    <hr>
                </div>
                <div class="col-md-12 align-self-center">
                  <div class="overview-img-block overview-img-block1">
                    <div class="portfolio-type position-relative">
                      <div class="d-inline-block" v-if="listing.data.listing[0].land_size !== 0">
                        <div class="row g-0">
                          <div class="col p-0">{{ listing.data.listing[0].land_size }} M2 LAND SIZE</div>
                        </div>
                      </div>
                      <div class="d-inline-block">
                        <div class="row g-0">
                          <div class="col p-0">{{ listing.data.listing[0].lounges }} LOUNGES</div>
                        </div>
                      </div>
                      <div class="d-inline-block">
                        <div class="row g-0">
                          <div class="col p-0">{{ listing.data.listing[0].bedrooms }} BEDS</div>
                        </div>
                      </div>
                      <div class="d-inline-block">
                        <div class="row g-0">
                          <div class="col p-0">{{ listing.data.listing[0].bathrooms }} BATHS</div>
                        </div>
                      </div>
                    </div>
                      <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                        <img :src="ogListing[0].listing_images[1]" class="mw-100 rounded" alt="" />
                    </button>     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-light">
          <div class="row">
            <div class="col-12 text-center mt-3">
              <h1>CONTACT DETAILS</h1>
              <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="bi bi-envelope"></i> &nbsp; &nbsp; Send a message
              </button>
            </div>
          </div>
          
          <div class="row justify-content-center pt-5 pb-5">
            <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" alt="Agent"/>
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                    <div v-if="!contactRequested">
                      <center><button id="contact-reveal-agent" class="btn btn-primary filter-btn" v-on:click="contactRequested = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                      <a id="email-agent-property" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                      <a id="whatsapp-agent-property" style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                    </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" alt="Agent 2" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                    <div v-if="!contactRequested_2">
                      <center><button id="contact-reveal-agent-2" class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_2">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                      <a id="email-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>\
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                    <div v-if="!contactRequested_3">
                      <center><button id="contact-reveal-agent-3" class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_3">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                      <a id="email-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wrapper">
          <div class="container mt-5">
            <div class="row mb-5">
              <div :class="{'col-md-12 mt-3': !listing.data.listing[0].video_id, 'col-md-8 mt-3': listing.data.listing[0].video_id}">
                  <h5 class="switch-blue">About this property</h5>
                  <p v-for="(paragraph, index) in formattedDescription" :key="index">{{ paragraph }}</p>
              </div>
              <div class="col-md-4 mt-5" v-if="listing.data.listing[0].video_id !== null">
                  <iframe
                    width="100%"
                    height="315"
                    v-if="listing.data.listing[0].video_id !== null"
                    :src="'https://www.youtube.com/embed/' + listing.data.listing[0].video_id + '?rel=0&modestbranding=1'"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
              </div>
            </div>
            
             <div class="row">
              <div id="carouselExampleIndicators" class="carousel slide">
                
                <div class="carousel-inner">
                  <div v-for="(item, index) in ogListing[0].listing_images">
                    <div class="carousel-item" :class="{ active: index == 2 }">
                      <div class="row justify-content-center">
                        <div class="col-sm-11">
                          <button
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasBottom"
                          aria-controls="offcanvasBottom"
                          @click="expandImage(index)"
                          style="padding: 0; border: none; background: transparent; display: block; width: 100%;"
                        >
                          <img
                            :src="item"
                            class="w-100"
                            :class="{ 'expanded': isImageExpanded && activeImageIndex === index }"
                          />
                        </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Amenities</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Activities</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">Schools</button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active switch-bg-lpblue p-lg-5 p-3" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Amenities
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingOne" data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Amenities</h5>
                            <p>{{ listing.ai_amenities_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade switch-bg-lpblue p-lg-5 p-3" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Activities
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingTwo" data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Activities</h5>
                            <p>{{ listing.ai_activities_description }}</p>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade switch-bg-lpblue p-lg-5 p-3" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Schools
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingThree" data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Schools</h5>
                            <p>{{ listing.ai_schools_description }}</p>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5 pt-4">
              <div :class="{'col-md-12 mt-3': !listing.data.listing[0].map_x_position, 'col-md-6 mt-3': listing.data.listing[0].map_x_position}">
                <h5 class="switch-blue">About this location</h5>
                <p>{{ listing.ai_location_description }}</p>
              </div>
              <div class="col-md-6 amenities2"  v-if="listing.data.listing[0].map_x_position != null">
                <iframe
                  v-if="listing.data.listing[0].map_x_position != null"
                  width="100%"
                  height="450"
                  frameborder="0"
                  style="border:0"
                  :src="'/map.html?lat=' + listing.data.listing[0].map_x_position + '&lng=' + listing.data.listing[0].map_y_position + '&zoom=12'"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="listing.template == 2 && !loading">
        <div id="banner" class="my-5">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="porfolio-banner">
                  <!-- Button wrapping the image to trigger offcanvas -->
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                      <img :src="listing.featured_image" class="w-100" style="border-top-right-radius: 50px;" alt="Portfolio Banner" />
                    </button>
                  <h1 class="text-md-start text-center p-2" style="background: rgba(255, 255, 255, 0.5)">{{ listing.data.listing[0].marketing_heading }}
                    <span>{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                    <span v-if="listing.data.listing[0].poa === true"><strong>POA</strong></span>
                    <span v-if="listing.data.listing[0].poa !== true"><strong>R {{ formattedPrice  }}</strong></span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        
          <!-- Offcanvas component -->
          <div class="offcanvas offcanvas-bottom" id="offcanvasBottom" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">GALLERY VIEW</h5>
              <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div class="offcanvas-body">
            <!-- Gallery Start In Offcanvas -->
          <div class="photo-album">
              <!-- First Row: 2 Large Images -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[0]" data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[0]"class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[1]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[1]" class="img-fluid" style="height: 500px; border-radius: 0; padding-right: 14px;"/>
                      </a>
                  </div>
              </div>

              <!-- Second Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[2]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[2]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[3]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[3]"class="img-fluid" style="height: 420px; border-radius: 0;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[4]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[4]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Third Row: 1 Large Image -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[5]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[5]" class="img-fluid" style="height: 770px; border-radius: 0; padding-left: 14px;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Fourth Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[6]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[6]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[7]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[7]" class="img-fluid" style="height: 420px; border-radius: 0;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[8]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[8]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Fifth Row: 1 Large Image -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[9]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[9]" class="img-fluid" style="height: 770px; border-radius: 0;  padding-left: 14px;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Sixth Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[10]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[10]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[11]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[11]" class="img-fluid" style="height: 420px; border-radius: 0; " />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[12]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[12]" class="img-fluid" style="height: 420px; border-radius: 0; padding-right: 14px;" />
                    </a>
                  </div>
              </div>


              <!-- Eleventh Row: 2 Large Images -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[13]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[13]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[14]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[14]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>
          </div>
          </div>
          </div>

          <!-- End of Gallery in Offcanvas -->

        
        <div class="container-fluid bg-light">
          <div class="row">
            <div class="col-12 text-center mt-3">
              <h1>CONTACT DETAILS</h1>
              <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="bi bi-envelope"></i> &nbsp; &nbsp; Send a message
              </button>
            </div>
          </div>
          
          <div class="row justify-content-center pt-5 pb-5">
            <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                    <div v-if="!contactRequested">
                      <center><button id="contact-reveal-agent" class="btn btn-primary filter-btn" v-on:click="contactRequested = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                      <a id="email-agent-property" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                      <a id="whatsapp-agent-property" style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                    </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                    <div v-if="!contactRequested_2">
                      <center><button id="contact-reveal-agent-2" class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_2">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                      <a id="email-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>\
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                    <div v-if="!contactRequested_3">
                      <center><button id="contact-reveal-agent-3" class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_3">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                      <a id="email-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

            <div class="switch-bg-dblue">
          <div class="wrapper">
            <div class="container position-relative py-5">
              <div class="row justify-content-center">
                <div class="col-lg-10 align-self-center my-4">
                  <div class="property-overview-block property-overview-block2">
                    <div v-if="listing.data.listing[0].poa !== true" class="price-tag text-end p-tag2">R {{ formattedPrice }}</div>
                    <div v-if="listing.data.listing[0].poa === true" class="price-tag text-end p-tag2">POA</div>
                    <h2 class=" text-start text-uppercase mb-4"><strong class="switch-white">{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}, {{ listing.data.listing[0].loc_country }}</strong></h2>
                    <div id="carouselTemplateTwo" class="carousel">
                <div class="carousel-inner">
                  <div v-for="(item, index) in ogListing[0].listing_images" :key="index">
                    <div class="carousel-item" :class="{ active: index == 1 }">
                      <button
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasBottom"
                        aria-controls="offcanvasBottom"
                        @click="expandImage(index)"
                        style="padding: 0; border: none; background: transparent; display: block; width: 100%;"
                      >
                <img :src="item" class="w-100 bord-radius" />
              </button>
            </div>
          </div>
        </div>

          <!-- Carousel Controls -->
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselTemplateTwo" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselTemplateTwo" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>

        <!-- Offcanvas structure -->
        <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
          <div class="offcanvas-header">
            <h5 id="offcanvasBottomLabel">Image Preview</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div class="offcanvas-body">
            <div class="row justify-content-center">
              <div class="col-sm-12 text-center">
                <!-- Display enlarged image -->
                <img :src="ogListing[0].listing_images[activeImageIndex]" class="w-100" />
              </div>
            </div>
          </div>
        </div>
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12 position-relative">
              <div class="portfolio-type portfolio-type2">
                <div class="d-inline-block" v-if="listing.data.listing[0].land_size !== 0">
                  <div class="row g-0">
                    <div class="col p-0">{{ listing.data.listing[0].land_size }} M2 LAND SIZE</div>
                  </div>
                </div>
                <div class="d-inline-block">
                  <div class="row g-0">
                    <div class="col p-0">{{ listing.data.listing[0].lounges }} LOUNGES</div>
                  </div>
                </div>
                <div class="d-inline-block">
                  <div class="row g-0">
                    <div class="col p-0">{{ listing.data.listing[0].bedrooms }} BEDS</div>
                  </div>
                </div>
                <div class="d-inline-block">
                  <div class="row g-0">
                    <div class="col p-0">{{ listing.data.listing[0].bathrooms }} BATHS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="wrapper pt-5">
          <div class="container mt-5">
            <div class="row">
              <div class="col-lg-12 text-center">
                <h5 class="switch-blue">Overview</h5>
                <p>{{ listing.ai_description }}</p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-lg-6">
                <h5 class="switch-blue mb-4">About this property</h5>
                <p v-for="(paragraph, index) in formattedDescription" :key="index">{{ paragraph }}</p>
              </div>
              <div class="col-lg-6 amenities2 mt-5">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#amenities-tab-temp3"
                      type="button" role="tab" aria-controls="amenities-tab-temp3" aria-selected="true">Amenities</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#main-tab-temp3"
                      type="button" role="tab" aria-controls="main-tab-temp3" aria-selected="false">Activities</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#outdoors-tab-temp3"
                      type="button" role="tab" aria-controls="outdoors-tab-temp3" aria-selected="false">Schools</button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active switch-bg-lpblue p-lg-5 p-3" id="amenities-tab-temp3"
                    role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Amenities
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingOne"
                      data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Amenities</h5>
                            <p>{{ listing.ai_amenities_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade switch-bg-lpblue p-lg-5 p-3" id="main-tab-temp3" role="tabpanel"
                    aria-labelledby="profile-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingTw0">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Activities
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingTw0"
                      data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Activities</h5>
                            <p>{{ listing.ai_activities_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade switch-bg-lpblue p-lg-5 p-3" id="outdoors-tab-temp3" role="tabpanel"
                    aria-labelledby="contact-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Schools
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingThree"
                      data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Schools</h5>
                            <p>{{ listing.ai_schools_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5" v-if="listing.data.listing[0].video_id">
                    <iframe
                      width="100%"
                      height="315"
                      :src="'https://www.youtube.com/embed/' + listing.data.listing[0].video_id + '?rel=0&modestbranding=1'"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                </div>
              </div>
            </div>
            <div class="row mt-5 mb-5">
              <div class="col-lg-6">
                <h5 class="switch-blue">ABOUT {{ listing.data.listing[0].loc_suburb }}</h5>
                <p>{{ this.listing.ai_location_description }}</p>
              </div>
              <div class="col-lg-6 amenities2">
                <iframe
                  width="100%"
                  height="450"
                  frameborder="0"
                  style="border:0"
                  v-if="listing.data.listing[0].map_x_position != null"
                  :src="'/map.html?lat=' + listing.data.listing[0].map_x_position + '&lng=' + listing.data.listing[0].map_y_position + '&zoom=12'"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="listing.template == 3 && !loading">
        <div id="banner" class="mb-5 mt-5">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-lg-4 switch-bg-lpblue ps-4 order-lg-1 order-2 position-relative bg-light">
                <div class="banner-section temp3">
                  <h1 class="text-start">{{ listing.data.listing[0].marketing_heading }}
                    <span>{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                  </h1>
                </div>

                   <!-- Offcanvas component -->
                  <div class="offcanvas offcanvas-bottom" id="offcanvasBottom" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
                    <div class="offcanvas-header">
                      <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">GALLERY VIEW</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>

                    <div class="offcanvas-body">
                    <!-- Gallery Start In Offcanvas -->
                  <div class="photo-album">
                      <!-- First Row: 2 Large Images -->
                      <div class="photo-row large">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[0]" data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[0]"class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[1]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[1]" class="img-fluid" style="height: 500px; border-radius: 0; padding-right: 14px;"/>
                              </a>
                          </div>
                      </div>

                      <!-- Second Row: 3 Smaller Images -->
                      <div class="photo-row small">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[2]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[2]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[3]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[3]"class="img-fluid" style="height: 420px; border-radius: 0;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[4]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[4]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                            </a>
                          </div>
                      </div>

                      <!-- Third Row: 1 Large Image -->
                      <div class="photo-row large">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[5]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[5]" class="img-fluid" style="height: 770px; border-radius: 0; padding-left: 14px;  padding-right: 14px;" />
                            </a>
                          </div>
                      </div>

                      <!-- Fourth Row: 3 Smaller Images -->
                      <div class="photo-row small">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[6]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[6]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[7]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[7]" class="img-fluid" style="height: 420px; border-radius: 0;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[8]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[8]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                            </a>
                          </div>
                      </div>

                      <!-- Fifth Row: 1 Large Image -->
                      <div class="photo-row large">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[9]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[9]" class="img-fluid" style="height: 770px; border-radius: 0;  padding-left: 14px;  padding-right: 14px;" />
                            </a>
                          </div>
                      </div>

                      <!-- Sixth Row: 3 Smaller Images -->
                      <div class="photo-row small">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[10]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[10]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[11]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[11]" class="img-fluid" style="height: 420px; border-radius: 0; " />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[12]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[12]" class="img-fluid" style="height: 420px; border-radius: 0; padding-right: 14px;" />
                            </a>
                          </div>
                      </div>


                      <!-- Eleventh Row: 2 Large Images -->
                      <div class="photo-row large">
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[13]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[13]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                            </a>
                          </div>
                          <div class="photo-item">
                            <a :href="ogListing[0].listing_images[14]"data-lightbox="mygallery">
                              <img :src="ogListing[0].listing_images[14]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-right: 14px;" />
                            </a>
                          </div>
                      </div>
                  </div>
                  </div>
                  </div>

                  <!-- End of Gallery in Offcanvas -->

                <div class="row justify-content-lg-end push50T">
                  <div class="col-lg-6  position-relative">
                    <div class="portfolio-type portfolio-type3">
                      <div class="type3"  v-if="listing.data.listing[0].land_size !== 0">
                        <div class="row g-0">
                          <div class="col-1"><img src="/images/icons/size-icon.png" class="mw-100" width="20px"></div>
                          <div class="col p-0">{{ listing.data.listing[0].land_size }} M2 LAND SIZE</div>
                        </div>
                      </div>
                      <div class="type3">
                        <div class="row g-0">
                          <div class="col-1"><img src="/images/icons/room-icon.png" class="mw-100" width="15px"></div>
                          <div class="col p-0">{{ listing.data.listing[0].lounges }} LOUNGES</div>
                        </div>
                      </div>
                      <div class="type3">
                        <div class="row g-0">
                          <div class="col-1"><img src="/images/icons/beds-icon.png" class="mw-100" width="20px"></div>
                          <div class="col p-0">{{ listing.data.listing[0].bedrooms }} BEDS</div>
                        </div>
                      </div>
                      <div class="type3">
                        <div class="row g-0">
                          <div class="col-1"><img src="/images/icons/baths-icon.png" class="mw-100" width="20px"></div>
                          <div class="col p-0">{{ listing.data.listing[0].bathrooms }} BATHS</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="social-block">
                  <div class="row">
                    
                  </div>
                </div>
              </div>
              <div class="col-lg-8 order-lg-2 order-1">
                <div class="porfolio-banner">
                   <!-- Button wrapping the image to trigger offcanvas -->
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                       <!-- Button wrapping the image to trigger offcanvas -->
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                      <img :src="listing.featured_image" class="w-100" style="border-top-right-radius: 30px;" />
                    </button>
                    </button>
                  <div v-if="listing.data.listing[0].poa !== true" class="price-tag text-end p-tag2" style="border-top-right-radius: 30px; border-top-left-radius: 30px; bottom: 0px;">R {{ formattedPrice }}</div>
                  <div v-if="listing.data.listing[0].poa === true" class="price-tag text-end p-tag2" style="border-top-right-radius: 30px; border-top-left-radius: 30px; bottom: 0px;">POA</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-light">
          <div class="row">
            <div class="col-12 text-center mt-3">
              <h1>CONTACT DETAILS</h1>
              <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="bi bi-envelope"></i> &nbsp; &nbsp; Send a message
              </button>
            </div>
          </div>
          
          <div class="row justify-content-center pt-5 pb-5">
            <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                    <div v-if="!contactRequested">
                      <center><button id="contact-reveal-agent" class="btn btn-primary filter-btn" v-on:click="contactRequested = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                      <a id="email-agent-property" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                      <a id="whatsapp-agent-property" style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                    </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                    <div v-if="!contactRequested_2">
                      <center><button id="contact-reveal-agent-2" class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_2">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                      <a id="email-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>\
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                    <div v-if="!contactRequested_3">
                      <center><button id="contact-reveal-agent-3" class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_3">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                      <a id="email-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <div class="wrapper">
            <div class="container">
              <div class="row mb-3">
                <div :class="{'col-md-12 mt-3': !listing.data.listing[0].video_id, 'col-md-7 mt-3': listing.data.listing[0].video_id}">
                  <h3 class="switch-blue">Overview</h3>
                  <p>{{ listing.ai_description }}</p>
                </div>
                <div class="col-md-5" v-if="listing.data.listing[0].video_id !== null || listing.data.listing[0].video_id != ''">
                    <iframe
                      width="100%"
                      height="315"
                      v-if="listing.data.listing[0].video_id !== null"
                      :src="'https://www.youtube.com/embed/' + listing.data.listing[0].video_id + '?rel=0&modestbranding=1'"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                </div>
              </div>
            </div>
          </div>
          <div class="switch-bg-lgrey">
            <div class="container position-relative py-md-5 pb-4">
              <div class="row justify-content-center">
                <div class="col-12 align-self-center my-4">
                  <div class="property-overview-block property-overview-block3" id="carousel-toggle">
                    <div id="carouselTemplateThree" class="carousel slide temp2">
                      <div class="carousel-inner">
                        <div class="carousel-item active">
                          <div class="row">
                           
                            <div class="col-12 col-md-4">
                          
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[8]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[9]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[10]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row">
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[11]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[12]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[13]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row">
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[0]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[1]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[2]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-indicators">
                      <button type="button" data-bs-target="#carouselTemplateThree" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                      <button type="button" data-bs-target="#carouselTemplateThree" data-bs-slide-to="1" aria-label="Slide 2"></button>
                      <button type="button" data-bs-target="#carouselTemplateThree" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselTemplateThree" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselTemplateThree" data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
          </div>
          </div>
           </div>
            </div>
             </div>

        <div class="wrapper">
          <div class="container mt-5">
            <div class="row mt-5">
              <div class="col-12">
                <h5 class="switch-blue mb-4">About this property</h5>
                <p v-for="(paragraph, index) in formattedDescription" :key="index">{{ paragraph }}</p>
              </div>
              <div class="col-12 amenities2 mt-5">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#amenities-tab-temp3"
                      type="button" role="tab" aria-controls="amenities-tab-temp3" aria-selected="true">Amenities</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#main-tab-temp3"
                      type="button" role="tab" aria-controls="main-tab-temp3" aria-selected="false">Activities</button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#outdoors-tab-temp3"
                      type="button" role="tab" aria-controls="outdoors-tab-temp3" aria-selected="false">Schools</button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active switch-bg-lpblue p-lg-5 p-3" id="amenities-tab-temp3"
                    role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Amenities
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingOne"
                      data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Amenities</h5>
                            <p>{{ listing.ai_amenities_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade switch-bg-lpblue p-lg-5 p-3" id="main-tab-temp3" role="tabpanel"
                    aria-labelledby="profile-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingTw0">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Activities
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingTw0"
                      data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Activities</h5>
                            <p>{{ listing.ai_activities_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade switch-bg-lpblue p-lg-5 p-3" id="outdoors-tab-temp3" role="tabpanel"
                    aria-labelledby="contact-tab" tabindex="0">
                    <h2 class="accordion-header d-lg-none" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Schools
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingThree"
                      data-bs-parent="#myTabContent">
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="switch-ddblue mb-4">Schools</h5>
                            <p>{{ listing.ai_schools_description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5 pt-4">
              <div :class="{'col-md-12 mt-3': !listing.data.listing[0].map_x_position, 'col-md-6 mt-3': listing.data.listing[0].map_x_position}">
                <h5 class="switch-blue">ABOUT {{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</h5>
                <p>{{ listing.ai_location_description }}</p>
              </div>
              <div class="col-lg-6 amenities2"  v-if="listing.data.listing[0].map_x_position != null">
                <iframe
                  width="100%"
                  height="450"
                  frameborder="0"
                  style="border:0"
                  v-if="listing.data.listing[0].map_x_position != null"
                  :src="'/map.html?lat=' + listing.data.listing[0].map_x_position + '&lng=' + listing.data.listing[0].map_y_position + '&zoom=12'"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="listing.template == 4 && !loading">
        <div id="banner" class="mt-5">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="banner-section porfolio-banner porfolio-banner4">
                   <!-- Button wrapping the image to trigger offcanvas -->
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                      <img :src="listing.featured_image" class="w-100" />
                    </button>
                  <div class="switch-bg-dblue name-property-details px-3 py-2">
                    <div class="row g-0">
                      <div class="col-lg-6 col-md-5">
                        <div class="">
                          <h4 class="text-sm-start text-center switch-white">{{ listing.data.listing[0].marketing_heading }}
                            <span class="mt-2">{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                          </h4>
                        </div>
                      </div>
                           <!-- Offcanvas component -->
                    <div class="offcanvas offcanvas-bottom" id="offcanvasBottom" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
                      <div class="offcanvas-header">
                        <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">GALLERY VIEW</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                      </div>

                      <div class="offcanvas-body">
                      <!-- Gallery Start In Offcanvas -->
                    <div class="photo-album">
                        <!-- First Row: 2 Large Images -->
                        <div class="photo-row large">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[0]" data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[0]"class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[1]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[1]" class="img-fluid" style="height: 500px; border-radius: 0; padding-right: 14px;"/>
                                </a>
                            </div>
                        </div>

                        <!-- Second Row: 3 Smaller Images -->
                        <div class="photo-row small">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[2]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[2]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[3]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[3]"class="img-fluid" style="height: 420px; border-radius: 0;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[4]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[4]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                              </a>
                            </div>
                        </div>

                        <!-- Third Row: 1 Large Image -->
                        <div class="photo-row large">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[5]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[5]" class="img-fluid" style="height: 770px; border-radius: 0; padding-left: 14px;  padding-right: 14px;" />
                              </a>
                            </div>
                        </div>

                        <!-- Fourth Row: 3 Smaller Images -->
                        <div class="photo-row small">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[6]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[6]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[7]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[7]" class="img-fluid" style="height: 420px; border-radius: 0;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[8]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[8]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                              </a>
                            </div>
                        </div>

                        <!-- Fifth Row: 1 Large Image -->
                        <div class="photo-row large">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[9]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[9]" class="img-fluid" style="height: 770px; border-radius: 0;  padding-left: 14px;  padding-right: 14px;" />
                              </a>
                            </div>
                        </div>

                        <!-- Sixth Row: 3 Smaller Images -->
                        <div class="photo-row small">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[10]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[10]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[11]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[11]" class="img-fluid" style="height: 420px; border-radius: 0; " />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[12]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[12]" class="img-fluid" style="height: 420px; border-radius: 0; padding-right: 14px;" />
                              </a>
                            </div>
                        </div>


                        <!-- Eleventh Row: 2 Large Images -->
                        <div class="photo-row large">
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[13]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[13]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                              </a>
                            </div>
                            <div class="photo-item">
                              <a :href="ogListing[0].listing_images[14]"data-lightbox="mygallery">
                                <img :src="ogListing[0].listing_images[14]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-right: 14px;" />
                              </a>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>

                    <!-- End of Gallery in Offcanvas -->

                      <div class="col-lg-6 col-md-7 align-self-center">
                        <div class="portfolio-type portfolio-type4 float-md-end">
                          <div class="type4" v-if="listing.data.listing[0].land_size !== 0">
                            <p>{{ listing.data.listing[0].land_size }}<br/>M2 LAND SIZE</p>
                          </div>
                          <div class="type4">
                            <p>{{ listing.data.listing[0].lounges }} <br/>LOUNGES</p>
                          </div>
                          <div class="type4">
                            <p>{{ listing.data.listing[0].bedrooms }} <br/>BEDS</p>
                          </div>
                          <div class="type4">
                            <p>{{ listing.data.listing[0].bathrooms }} <br/>BATHS</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="listing.data.listing[0].poa !== true" class="price-tag text-end p-tag2">R {{ formattedPrice }}</div>
                  <div v-if="listing.data.listing[0].poa === true" class="price-tag text-end p-tag2">POA</div>

                  <div class="row g-0 justify-content-center">
                    <div class="col-lg-12 col-md-12 col-sm-10 order-md-1 order-2">
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-light">
          <div class="row">
            <div class="col-12 text-center mt-3">
              <h1>CONTACT DETAILS</h1>
               <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="bi bi-envelope"></i> &nbsp; &nbsp; Send a message
              </button>
            </div>
          </div>
          
          <div class="row justify-content-center pt-5 pb-5">
            <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                    <div v-if="!contactRequested">
                      <center><button id="contact-reveal-agent" class="btn btn-primary filter-btn" v-on:click="contactRequested = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                      <a id="email-agent-property" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                      <a id="whatsapp-agent-property" style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                    </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                    <div v-if="!contactRequested_2">
                      <center><button id="contact-reveal-agent-2" class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_2">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                      <a id="email-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>\
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                    <div v-if="!contactRequested_3">
                      <center><button id="contact-reveal-agent-3" class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_3">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                      <a id="email-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <div class="wrapper">
            <div class="container">
              <div class="row">
                <div class="col-12 text-center mb-5 mt-5">
                  <h5 class="switch-blue">Overview</h5>
                  <p>{{ listing.ai_description }}</p>
                </div>
                <div class="col-lg-6 amenities2">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                        data-bs-target="#amenities-tab-temp4" type="button" role="tab" aria-controls="amenities-tab-temp4"
                        aria-selected="true">Amenities</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#main-tab-temp4"
                        type="button" role="tab" aria-controls="main-tab-temp4" aria-selected="false">Activities</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#outdoors-tab-temp4"
                        type="button" role="tab" aria-controls="outdoors-tab-temp4" aria-selected="false">Schools</button>
                    </li>
                  </ul>

                  <div class="tab-content tabs-temp4" id="myTabContent">
                    <div class="tab-pane fade show active switch-bg-dblue p-lg-5 p-3 h-100" id="amenities-tab-temp4"
                      role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                      <h2 class="accordion-header d-lg-none" id="headingOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                          Amenities
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingOne"
                        data-bs-parent="#myTabContent">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="switch-ddblue mb-4">Amenities</h5>
                              <p>{{ listing.ai_amenities_description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade p-lg-5 p-3 switch-bg-dblue h-100" id="main-tab-temp4" role="tabpanel"
                      aria-labelledby="profile-tab" tabindex="0">
                      <h2 class="accordion-header d-lg-none" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          Activities
                        </button>
                      </h2>
                      <div id="collapseTwo" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingTwo"
                        data-bs-parent="#myTabContent">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="switch-ddblue mb-4">Activities</h5>
                              <p>{{ listing.ai_activities_description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="tab-pane fade p-lg-5 p-3 switch-bg-dblue h-100" id="outdoors-tab-temp4" role="tabpanel"
                      aria-labelledby="contact-tab" tabindex="0">
                      <h2 class="accordion-header d-lg-none" id="headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Schools
                        </button>
                      </h2>
                      <div id="collapseThree" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingThree"
                        data-bs-parent="#myTabContent">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="switch-ddblue mb-4">Schools</h5>
                              <p>{{ listing.ai_schools_description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 align-self-center pt-5">
                  <div class="row">
                    <div>
                      <div id="carouselExampleIndicators" class="carousel slide">
                        <div class="carousel-inner">
                          <div v-for="(item, index) in ogListing[0].listing_images">
                            <div class="carousel-item" :class="{ active: index == 2 }">
                              <div class="row justify-content-center">
                                <div class="col-sm-11">
                                  <img
                                    :src="item"
                                    class="w-100"
                                    @click="expandImage(index)"
                                    :class="{ 'expanded': isImageExpanded && activeImageIndex === index }"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wrapper pt-5">
            <div class="container mt-5">
              <div class="row mt-5">
                <div class="col-12 text-start">
                  <h5 class="switch-blue mb-4">About this property</h5>
                  <p v-for="(paragraph, index) in formattedDescription" :key="index">{{ paragraph }}</p>
                  <iframe
                    width="100%"
                    height="315"
                    v-if="listing.data.listing[0].video_id !== null"
                    :src="'https://www.youtube.com/embed/' + listing.data.listing[0].video_id + '?rel=0&modestbranding=1'"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                  <h5 class="switch-blue mt-4 mb-4">ABOUT {{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</h5>
                  <p>{{ listing.ai_location_description }}</p>
                  <div  v-if="listing.data.listing[0].map_x_position != null">
                  <iframe 
                    width="100%"
                    height="450"
                    frameborder="0"
                    style="border:0"
                    v-if="listing.data.listing[0].map_x_position != null"
                    :src="'/map.html?lat=' + listing.data.listing[0].map_x_position + '&lng=' + listing.data.listing[0].map_y_position + '&zoom=12'"
                    allowfullscreen
                  ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="listing.template == 5 && !loading">
        <div id="banner" class="my-5">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="banner-section porfolio-banner porfolio-banner5 ">
                  <div id="carouselTemplateFive" class="carousel slide">
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                         <!-- Button wrapping the image to trigger offcanvas -->
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                      <img :src="listing.featured_image" class="w-100 no-border" />
                    </button>
                        <div class="row">
                          <div class="col-md-7">
                            <div class="port-type5">
                              <h4 class="text-start switch-white">{{ listing.data.listing[0].marketing_heading }}
                                <span class="mt-2">{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                                <span v-if="listing.data.listing[0].poa !== true" class="mt-2"><strong style="color: white; font-size: 18px;">R {{ formattedPrice }}</strong></span>
                                <span v-if="listing.data.listing[0].poa === true" class="mt-2"><strong style="color: white; font-size: 18px;">POA</strong></span>
                              </h4>
                              <p class="switch-white">{{ listing.ai_description }}</p>
                            </div>
                          </div>
                              <!-- Offcanvas component -->
                          <div class="offcanvas offcanvas-bottom" id="offcanvasBottom" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
                            <div class="offcanvas-header">
                              <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">GALLERY VIEW</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>

                            <div class="offcanvas-body">
                            <!-- Gallery Start In Offcanvas -->
                          <div class="photo-album">
                              <!-- First Row: 2 Large Images -->
                              <div class="photo-row large">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[0]" data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[0]"class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[1]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[1]" class="img-fluid" style="height: 500px; border-radius: 0; padding-right: 14px;"/>
                                      </a>
                                  </div>
                              </div>

                              <!-- Second Row: 3 Smaller Images -->
                              <div class="photo-row small">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[2]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[2]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[3]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[3]"class="img-fluid" style="height: 420px; border-radius: 0;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[4]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[4]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                                    </a>
                                  </div>
                              </div>

                              <!-- Third Row: 1 Large Image -->
                              <div class="photo-row large">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[5]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[5]" class="img-fluid" style="height: 770px; border-radius: 0; padding-left: 14px;  padding-right: 14px;" />
                                    </a>
                                  </div>
                              </div>

                              <!-- Fourth Row: 3 Smaller Images -->
                              <div class="photo-row small">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[6]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[6]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[7]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[7]" class="img-fluid" style="height: 420px; border-radius: 0;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[8]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[8]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                                    </a>
                                  </div>
                              </div>

                              <!-- Fifth Row: 1 Large Image -->
                              <div class="photo-row large">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[9]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[9]" class="img-fluid" style="height: 770px; border-radius: 0;  padding-left: 14px;  padding-right: 14px;" />
                                    </a>
                                  </div>
                              </div>

                              <!-- Sixth Row: 3 Smaller Images -->
                              <div class="photo-row small">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[10]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[10]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[11]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[11]" class="img-fluid" style="height: 420px; border-radius: 0; " />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[12]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[12]" class="img-fluid" style="height: 420px; border-radius: 0; padding-right: 14px;" />
                                    </a>
                                  </div>
                              </div>


                              <!-- Eleventh Row: 2 Large Images -->
                              <div class="photo-row large">
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[13]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[13]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                                    </a>
                                  </div>
                                  <div class="photo-item">
                                    <a :href="ogListing[0].listing_images[14]"data-lightbox="mygallery">
                                      <img :src="ogListing[0].listing_images[14]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-right: 14px;" />
                                    </a>
                                  </div>
                              </div>
                          </div>
                          </div>
                          </div>

                          <!-- End of Gallery in Offcanvas -->

                              <div class="col-md-5">
                            <div class="carousel-indicators">
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="0"
                                aria-current="true" aria-label="Slide 1" class="active">
                                <img :src="listing.featured_image" class="mw-100" />
                              </button>
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="1"
                                aria-label="Slide 2">
                                <img :src="ogListing[0].listing_images[1]" class="mw-100" />
                              </button>
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="2"
                                aria-label="Slide 3">
                                <img :src="ogListing[0].listing_images[2]" class="mw-100" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <img :src="ogListing[0].listing_images[1]" class="w-100 no-borderR" />
                        <div class="row">
                          <div class="col-md-7">
                            <div class="port-type5">
                              <h4 class="text-start switch-white">{{ listing.data.listing[0].marketing_heading }}
                                <span class="mt-2">{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                              </h4>
                              <p class="switch-white">{{ listing.ai_description }}</p>
                            </div>
                          </div>
                          <div class="col-md-5">
                            <div class="carousel-indicators">
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="0"
                                aria-current="true" aria-label="Slide 1">
                                <img :src="ogListing[0].listing_images[0]" class="mw-100" />
                              </button>
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="1"
                                aria-label="Slide 2" class="active">
                                <img :src="ogListing[0].listing_images[1]" class="mw-100" />
                              </button>
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="2"
                                aria-label="Slide 3">
                                <img :src="ogListing[0].listing_images[2]" class="mw-100" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <img :src="ogListing[0].listing_images[2]" class="w-100 no-borderR" />
                        <div class="row">
                          <div class="col-md-7">
                            <div class="port-type5">
                              <h4 class="text-start switch-white">{{ listing.data.listing[0].marketing_heading }}
                                <span class="mt-2">{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span>
                              </h4>
                              <p class="switch-white">{{ listing.ai_description }}</p>
                            </div>
                          </div>
                          <div class="col-md-5">
                            <div class="carousel-indicators">
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="0"
                                aria-current="true" aria-label="Slide 1">
                                <img :src="ogListing[0].listing_images[0]" class="mw-100" />
                              </button>
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="1"
                                aria-label="Slide 2">
                                <img :src="ogListing[0].listing_images[1]" class="mw-100" />
                              </button>
                              <button type="button" data-bs-target="#carouselTemplateFive" data-bs-slide-to="2"
                                aria-label="Slide 3" class="active">
                                <img :src="ogListing[0].listing_images[2]" class="mw-100" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button class="carousel-control-prev carousel-btn" type="button" data-bs-target="#carouselTemplateFive"
                      data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next carousel-btn" type="button" data-bs-target="#carouselTemplateFive"
                      data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>

                  <div class="switch-bg-dblue name-property-details px-3 py-2">
                    <div class="row justify-content-between">
                      <div class="col-lg-8 col-md-7 align-self-center">
                        <div class="portfolio-type portfolio-type4 portfolio-type5">
                          <div class="type4 type5" v-if="listing.data.listing[0].land_size !== 0">
                            <img src="/images/icons/size-icon.png" class="mw-100 d-block" width="23px">
                            <p>{{ listing.data.listing[0].land_size }} M2 LAND SIZE</p>
                          </div>
                          <div class="type4 type5">
                            <img src="/images/icons/room-icon.png" class="mw-100 d-block" width="15px">
                            <p>{{ listing.data.listing[0].lounges }} LOUNGES</p>
                          </div>
                          <div class="type4 type5">
                            <img src="/images/icons/beds-icon.png" class="mw-100 d-block" width="24px">
                            <p>{{ listing.data.listing[0].bedrooms }} BEDROOMS</p>
                          </div>
                          <div class="type4 type5">
                            <img src="/images/icons/baths-icon.png" class="mw-100 d-block" width="31px">
                            <p>{{ listing.data.listing[0].bathrooms }} BATHS</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-5 align-self-center">
                        <div class="portfolio-type portfolio-type4 ">
                          <div class="type4 type5 switch-bg-white position-relative">
                            <p class="my-0" v-if="listing.data.listing[0].poa !== true"><strong>R {{ formattedPrice }}</strong></p>
                            <p class="my-0" v-if="listing.data.listing[0].poa === true"><strong>POA</strong></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid bg-light">
          <div class="row">
            <div class="col-12 text-center mt-3">
              <h1>CONTACT DETAILS</h1>
              <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                <i class="bi bi-envelope"></i> &nbsp; &nbsp; Send a message
              </button>
            </div>
          </div>
          
          <div class="row justify-content-center pt-5 pb-5">
            <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                    <div v-if="!contactRequested">
                      <center><button id="contact-reveal-agent" class="btn btn-primary filter-btn" v-on:click="contactRequested = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                      <a id="email-agent-property" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                      <a id="whatsapp-agent-property" style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                    </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                    <div v-if="!contactRequested_2">
                      <center><button id="contact-reveal-agent-2" class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_2">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                      <a id="email-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>\
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
              <div class="container">
                <div class="row pt-4">
                  <div class="col-md-5">
                    <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                  </div>
                  <div class="col-md-7 text-center">
                    <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                    <div v-if="!contactRequested_3">
                      <center><button id="contact-reveal-agent-3" class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true; incrementLeads();">Details</button></center>
                    </div>
                    <div v-if="contactRequested_3">
                      <p style="line-height: 26px;">
                      <a id="call-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                      <a id="email-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                      <a id="whatsapp-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-5">
          <div class="wrapper">
            <div class="container">
              <div class="row">
                <div class="col-md-12 mb-5">
                  <h5 class="switch-blue mb-4">About this property</h5>
                  <p v-for="(paragraph, index) in formattedDescription" :key="index">{{ paragraph }}</p>
                  <iframe
                    width="100%"
                    height="315"
                    v-if="listing.data.listing[0].video_id !== null"
                    :src="'https://www.youtube.com/embed/' + listing.data.listing[0].video_id + '?rel=0&modestbranding=1'"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                  <div class="slider-block mt-5">
                    <img :src="ogListing[0].listing_images[4]" class="w-100" />
                    <div id="carouselExample" class="carousel slide">
                      <div class="carousel-inner">
                        <div class="carousel-item active switch-bg-dblue p-4 px-5">
                          <h5 class=" mb-4">AMENITIES</h5>
                          <p>{{ listing.ai_amenities_description }}</p>
                        </div>
                        <div class="carousel-item switch-bg-dblue p-4 px-5">
                          <h5 class=" mb-4">ACTIVITIES</h5>
                          <p>{{ listing.ai_activities_description }}</p>
                        </div>
                        <div class="carousel-item switch-bg-dblue p-4 px-5">
                          <h5 class=" mb-4">SCHOOLS</h5>
                          <p>{{ listing.ai_schools_description }}</p>
                        </div>
                      </div>
                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExample"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wrapper">
            <div class="container">
              <div class="row mt-5">
                <div class="col-12">
                  <h5 class="switch-blue mt-5">ABOUT</h5>
                  <p>{{ listing.ai_location_description }}</p>
                  <div v-if="listing.data.listing[0].map_x_position != null">
                  <iframe
                  width="100%"
                  height="450"
                  frameborder="0"
                  style="border:0"
                  v-if="listing.data.listing[0].map_x_position != null"
                  :src="'/map.html?lat=' + listing.data.listing[0].map_x_position + '&lng=' + listing.data.listing[0].map_y_position + '&zoom=12'"
                  allowfullscreen
                  ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="listing.template == 6 && !loading">
        <div id="banner" class="mt-5 mb-3">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="banner-section porfolio-banner porfolio-banner6">
                  <div class="row g-0">
                    <div class="col-lg-4 col-md-5 align-self-center order-1 pe-2">
                      <h4>{{ listing.data.listing[0].marketing_heading }}<span>{{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</span></h4>
                      <div class="underLineBorder"></div>
                      <div class="priceTag pb-3" v-if="listing.data.listing[0].poa !== true">R {{ formattedPrice }}</div>
                      <div class="priceTag pb-3" v-if="listing.data.listing[0].poa === true">POA</div>
                    </div>
                      <div class="col-lg-8 col-md-6 col-sm-7 order-md-2 order-sm-4 order-2">
                    <!-- Button wrapping the image to trigger offcanvas -->
                    <button type="button" class="btn" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent; width: 100%; height: auto;">
                      <img :src="listing.featured_image" class="mw-100" style="border-top-left-radius: 30px;" />
                    </button>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

          <!-- Offcanvas component -->
          <div class="offcanvas offcanvas-bottom" id="offcanvasBottom" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">GALLERY VIEW</h5>
              <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div class="offcanvas-body">
            <!-- Gallery Start In Offcanvas -->
          <div class="photo-album">
              <!-- First Row: 2 Large Images -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[0]" data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[0]"class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[1]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[1]" class="img-fluid" style="height: 500px; border-radius: 0; padding-right: 14px;"/>
                      </a>
                  </div>
              </div>

              <!-- Second Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[2]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[2]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[3]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[3]"class="img-fluid" style="height: 420px; border-radius: 0;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[4]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[4]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Third Row: 1 Large Image -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[5]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[5]" class="img-fluid" style="height: 770px; border-radius: 0; padding-left: 14px;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Fourth Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[6]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[6]" class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[7]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[7]" class="img-fluid" style="height: 420px; border-radius: 0;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[8]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[8]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Fifth Row: 1 Large Image -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[9]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[9]" class="img-fluid" style="height: 770px; border-radius: 0;  padding-left: 14px;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>

              <!-- Sixth Row: 3 Smaller Images -->
              <div class="photo-row small">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[10]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[10]"class="img-fluid" style="height: 420px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[11]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[11]" class="img-fluid" style="height: 420px; border-radius: 0; " />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[12]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[12]" class="img-fluid" style="height: 420px; border-radius: 0; padding-right: 14px;" />
                    </a>
                  </div>
              </div>


              <!-- Eleventh Row: 2 Large Images -->
              <div class="photo-row large">
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[13]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[13]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-left: 14px;" />
                    </a>
                  </div>
                  <div class="photo-item">
                    <a :href="ogListing[0].listing_images[14]"data-lightbox="mygallery">
                      <img :src="ogListing[0].listing_images[14]" class="img-fluid" style="height: 500px; border-radius: 0;  padding-right: 14px;" />
                    </a>
                  </div>
              </div>
          </div>
          </div>
          </div>

          <!-- End of Gallery in Offcanvas -->

           <!-- Gallery Start -->
    <table style="width: 100%; border: none; padding: 2px; margin: 0;">
      <tbody>
        <tr>
          <!-- Featured Image -->
          <td class="featured-image-2" style="width: 53%; padding-right: 2px; padding-left: 72px;">
            <button
              type="button"
              class="btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
              style="padding: 0; border: none; background: transparent; width: 100%; height: 470px;"
            >
              <img :src="ogListing[0].listing_images[2]" style="width: 100%; height: 470px;" />
            </button>
        </td>

      <!-- Smaller Images -->
      <td style="width: 47%; padding-left: 2px; padding-right: 72px; vertical-align: top;">
        <div style="display: flex; flex-wrap: wrap; gap: 4px;">

          <!-- Image 1 -->
          <div style="width: calc(50% - 2px);">
            <button
              type="button"
              class="btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
              style="padding: 0; border: none; background: transparent; width: 100%; height: 234px;"
            >
              <img :src="ogListing[0].listing_images[4]" class="mw-100 zoomable-image" style="width:  100%; height: 234px;" />
            </button>
          </div>

          <!-- Image 2 -->
          <div style="width: calc(50% - 2px);">
            <button
              type="button"
              class="btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
              style="padding: 0; border: none; background: transparent; width: 100%; height: 234px;"
            >
              <img :src="ogListing[0].listing_images[5]" class="mw-100 zoomable-image" style="width: 100%; height: 234px;" />
            </button>
          </div>

          <!-- Image 3 -->
          <div style="width: calc(50% - 2px);">
            <button
              type="button"
              class="btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
              style="padding: 0; border: none; background: transparent; width: 100%; height: 230px;"
            >
              <img :src="ogListing[0].listing_images[6]" class="mw-100 zoomable-image" style="width: 100%; height: 230px;" />
            </button>
          </div>

          <!-- Image 4 -->
          <div style="width: calc(50% - 2px);">
            <button
              type="button"
              class="btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
              style="padding: 0; border: none; background: transparent; width: 100%; height: 230px;"
            >
              <img :src="ogListing[0].listing_images[7]" class="mw-100 zoomable-image" style="width: 100%; height: 230px;" />
            </button>
          </div>

        </div>
      </td>
    </tr>
  </tbody>
</table>
<!-- Gallery End -->


      
        <div class="pt-lg-5">
          <div class="wrapper">
            <div class="container">
              <div class="row">
                <div class="col-12  mb-5">
                  <div class="switch-bg-lgrey p-sm-5 p-4 pb-5 about-block">
                    <h5 class="switch-ddblue mb-4">About this property</h5>
                    <p v-for="(paragraph, index) in formattedDescription" :key="index">{{ paragraph }}</p>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center pb-5 mb-5">
                <div class="col-md-3 col-sm-6">
                  <div class="prop-details">{{ listing.data.listing[0].bedrooms }}<span>TOTAL BEDS</span></div>
                </div>
                <div class="col-md-3 col-sm-6" v-if="listing.data.listing[0].land_size !== 0">
                  <div class="prop-details">{{ listing.data.listing[0].land_size }}<span>M2 LAND SIZE</span></div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="prop-details">{{ listing.data.listing[0].lounges }}<span>TOTAL LOUNGES</span></div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="prop-details">{{ listing.data.listing[0].bathrooms }}<span>TOTAL BATHROOMS</span></div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid bg-light">
            <div class="row">
              <div class="col-12 text-center mt-3">
                <h1>CONTACT DETAILS</h1>
                <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                  <i class="bi bi-envelope"></i> &nbsp; &nbsp; Send a message
                </button>
              </div>
            </div>
            
            <div class="row justify-content-center pt-5 pb-5">
              <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
                <div class="container">
                  <div class="row pt-4">
                    <div class="col-md-5">
                      <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                    </div>
                    <div class="col-md-7 text-center">
                      <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                      <div v-if="!contactRequested">
                        <center><button id="contact-reveal-agent" class="btn btn-primary filter-btn" v-on:click="contactRequested = true; incrementLeads();">Details</button></center>
                      </div>
                      <div v-if="contactRequested">
                        <p style="line-height: 26px;">
                        <a id="call-agent-property" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                        <a id="email-agent-property" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                        <a id="whatsapp-agent-property" style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                      </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
                <div class="container">
                  <div class="row pt-4">
                    <div class="col-md-5">
                      <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                    </div>
                    <div class="col-md-7 text-center">
                      <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                      <div v-if="!contactRequested_2">
                        <center><button id="contact-reveal-agent-2" class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true; incrementLeads();">Details</button></center>
                      </div>
                      <div v-if="contactRequested_2">
                        <p style="line-height: 26px;">
                        <a id="call-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                        <a id="email-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                        <a id="whatsapp-agent-property-2" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>\
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
                <div class="container">
                  <div class="row pt-4">
                    <div class="col-md-5">
                      <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
                    </div>
                    <div class="col-md-7 text-center">
                      <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                      <div v-if="!contactRequested_3">
                        <center><button id="contact-reveal-agent-3" class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true; incrementLeads();">Details</button></center>
                      </div>
                      <div v-if="contactRequested_3">
                        <p style="line-height: 26px;">
                        <a id="call-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                        <a id="email-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                        <a id="whatsapp-agent-property-3" style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="wrapper">
            <div class="container">
              <div class="row mt-5">
                <div class="col-12 align-self-center my-4">
                  <iframe
                    width="100%"
                    height="315"
                    v-if="listing.data.listing[0].video_id !== null"
                    :src="'https://www.youtube.com/embed/' + listing.data.listing[0].video_id + '?rel=0&modestbranding=1'"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>



                  <div class="property-overview-block property-overview-block3 mt-5" id="carousel-toggle">
                  <div id="carouselTemplateThree" class="carousel slide temp2">
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <div class="row">
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[8]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[9]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[10]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row">
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[11]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[12]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[13]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row">
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[0]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[1]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                          <div class="col-12 col-md-4">
                            <!-- Button wrapping the image to trigger offcanvas -->
                            <button type="button" class="carousel-zoom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom" style="padding: 0; border: none; background: transparent;">
                              <img :src="ogListing[0].listing_images[2]" class="mw-100 zoomable-image equal-height" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-indicators">
                      <button type="button" data-bs-target="#carouselTemplateThree" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                      <button type="button" data-bs-target="#carouselTemplateThree" data-bs-slide-to="1" aria-label="Slide 2"></button>
                      <button type="button" data-bs-target="#carouselTemplateThree" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselTemplateThree" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselTemplateThree" data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
                </div>
                  
                <div class="col-12 mt-4">
                  <ul class="nav nav-tabs temp6-tabs justify-content-center" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="border-tab" data-bs-toggle="tab" data-bs-target="#border-tab-pane"
                        type="button" role="tab" aria-controls="border-tab-pane" aria-selected="true">Amenities</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="border2-tab" data-bs-toggle="tab" data-bs-target="#border2-tab-pane"
                        type="button" role="tab" aria-controls="border2-tab-pane" aria-selected="false">Activities</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="border3-tab" data-bs-toggle="tab" data-bs-target="#border3-tab-pane"
                        type="button" role="tab" aria-controls="border3-tab-pane" aria-selected="false">Schools</button>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active p-lg-5 p-3" id="border-tab-pane" role="tabpanel"
                      aria-labelledby="border-tab" tabindex="0">
                      <h2 class="accordion-header d-lg-none" id="headingOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                          Amenities
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingOne"
                        data-bs-parent="#myTabContent">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-12 align-self-center">
                              <h5 class="switch-ddblue mb-4">Amenities</h5>
                              <p>{{ listing.ai_amenities_description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane fade p-lg-5 p-3" id="border2-tab-pane" role="tabpanel"
                      aria-labelledby="border2-tab" tabindex="0">
                      <h2 class="accordion-header d-lg-none" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          Activities
                        </button>
                      </h2>
                      <div id="collapseTwo" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingTwo"
                        data-bs-parent="#myTabContent">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-12 align-self-center">
                              <h5 class="switch-ddblue mb-4">Activities</h5>
                              <p>{{ listing.ai_activities_description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="tab-pane fade p-lg-5 p-3" id="border3-tab-pane" role="tabpanel"
                      aria-labelledby="border3-tab" tabindex="0">
                      <h2 class="accordion-header d-lg-none" id="headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Schools
                        </button>
                      </h2>
                      <div id="collapseThree" class="accordion-collapse collapse d-lg-block" aria-labelledby="headingThree"
                        data-bs-parent="#myTabContent">
                        <div class="accordion-body">
                          <div class="row">
                            <div class="col-12 align-self-center">
                              <h5 class="switch-ddblue mb-4">Schools</h5>
                              <p>{{ listing.ai_schools_description }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-md-12 text-center">
                  <h5 class="switch-blue">ABOUT {{ listing.data.listing[0].loc_suburb }}, {{ listing.data.listing[0].loc_region }}</h5>
                  <p>{{ listing.ai_location_description }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" v-if="listing.data.listing[0].map_x_position !== null">
                  <iframe
                    width="100%"
                    height="450"
                    frameborder="0"
                    style="border:0"
                    :src="'/map.html?lat=' + listing.data.listing[0].map_x_position + '&lng=' + listing.data.listing[0].map_y_position + '&zoom=12'"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      

      <!-- OTHER PROPERTIES FROM THIS PROPERTY'S AGENT(S) -->
      <section class="agent-related-properties py-5" v-if="relatedProperties.length">
        <div class="container">
          <div class="row mb-4">
            <div class="col-12 text-center">
              <h3 class="switch-blue mb-2"><strong>MORE PROPERTIES FROM {{ relatedAgentHeading }}</strong></h3>
              <p class="mb-0">Explore more properties represented by this property's agent{{ currentAgentIds.length > 1 ? 's' : '' }}.</p>
            </div>
          </div>

          <div class="row justify-content-center g-4">
            <div
              class="col-12 col-md-6 col-lg-4"
              v-for="property in relatedProperties"
              :key="property.id"
            >
              <div class="agent-related-card h-100">
                <a :href="property.url" class="agent-related-image-link">
                  <div class="agent-related-image-wrap">
                    <img
                      :src="property.image"
                      :alt="property.heading"
                      class="agent-related-image"
                    >

                    <div class="agent-related-price-badge"><strong>
                      {{ formatCurrency(property.price) }}<span v-if="property.isRental"> PM</span></strong>
                    </div>

                    <div class="agent-related-status-badge">
                      {{ property.isRental ? 'TO RENT' : 'FOR SALE' }}
                    </div>
                  </div>
                </a>

                <div class="agent-related-content">
                  <h4 class="agent-related-title mb-2">{{ property.heading }}</h4>
                  <p class="agent-related-location mb-3">
                    <i class="bi bi-geo-alt-fill"></i>
                    {{ property.location }}
                  </p>
                  <p class="agent-related-description mb-0" v-if="property.description">
                    {{ property.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div v-for="item in navigationButtons" v-if="item.currentId == current">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center mt-5">
              <p><strong>Browse our portfolio</strong></p>
            </div>
          </div>
        </div>
        <center>
          <a class="btn btn-primary" v-if="item.lastId != null" :href="'/rental/' + item.lastId"><i class="bi bi-arrow-left"></i> Prev</a> 
          <a class="btn btn-primary" v-if="item.nextId != null" :href="'/rental/' + item.nextId">Next <i class="bi bi-arrow-right"></i></a>
        </center>
      </div>
      
      <!-- <div class="container pb-5 mb-5">
        <div class="row pt-5 justify-content-center">
          <div class="col-md-4 mt-5 mb-4 pb-4" v-for="(item, index) in originalListings" :key="index" v-if="originalListings[index] && originalListings[index].payload.listing.featured_image != null && originalListings[index].payload.listing.data.listing[0].loc_suburb == listing.data.listing[0].loc_suburb && originalListings[index].payload.listing.data.listing[0].id != listing.data.listing[0].id">
            <center>
              <p>Also in {{ originalListings[index].payload.listing.data.listing[0].loc_suburb }}</p>
            </center>
            <div class="banner-section lifestyle-block switch-bg-lgrey p-3 h-100 bord-radius">
              <div class="portfolio-thumbnail">
                <a :href="'/property/' + originalListings[index].payload.listing.data.listing[0].id">
                  <img :src="originalListings[index].payload.listing.featured_image" class="w-100 force-height">
                </a>
                <div class="thumbnail-priceTag">
                  {{ formatCurrency(originalListings[index].payload.listing.data.listing[0].price) }}
                </div>
                <div class="portfolio-type">
                  <div class="typeOne mx-1" v-for="(tag, propertyName) in originalListings[index].payload.listing.tags" v-if="tag == true">
                    {{ propertyName }}
                  </div>
                </div>
              </div>
              <h4 class="text-start">
                {{ originalListings[index].payload.listing.data.listing[0].marketing_heading }}
                <span>
                  {{ originalListings[index].payload.listing.data.listing[0].loc_suburb }},
                  {{ originalListings[index].payload.listing.data.listing[0].loc_region }}
                </span>
              </h4>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" :href="'/property/' + originalListings[index].payload.listing.data.listing[0].id">
              FIND OUT MORE
            </a>
          </div>
        </div>
      </div> -->
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios';
import Menu from '@/components/home/Menu.vue';
import Footer from '@/components/home/Footer.vue';
import ContactForm from '@/components/home/ContactForm.vue';

export default {
  components: {
    Menu, Footer, ContactForm
  },
  data() {
    return {
      listing: { 
        data: {
          listing: [
            { on_show: false }
          ]
        }
      },
      agent: { },
      agent_2: { },
      agent_3: { },
      loading: false,
      template: 1,
      activeImageIndex: -1,
      isImageExpanded: false,
      isImageClicked: false,
      originalListings: null,
      listings: null,
      contactRequested: false,
      contactRequested_2: false,
      contactRequested_3: false,
      whatsappLink: '',
      whatsappLink_2: '',
      whatsappLink_3: '',
      current: '',
      next: '',
      prev: '',
      navigationButtons: [],
      relatedProperties: [],
      ogListing: ''
    };
  },
  async created() {
    await Promise.all([
      this.fetchListing(),
      this.fetchListings()
    ]);

    const ogImage = document.getElementById("ogImage");
    const ogTitle = document.getElementById("ogTitle");

    if (ogImage && this.listing && this.listing.featured_image) {
      ogImage.setAttribute("content", this.listing.featured_image);
    }

    if (
      ogTitle &&
      this.listing &&
      this.listing.data &&
      this.listing.data.listing &&
      this.listing.data.listing[0]
    ) {
      ogTitle.setAttribute("content", this.listing.data.listing[0].marketing_heading);
    }

    await this.fetchRelatedProperties();

    this.navigationButtons = JSON.parse(localStorage.getItem('setNavigationButtons'))
    this.current = this.$route.params.propertyId
  },
  mounted() {
    this.incrementViews()
  },
  computed: {
    currentAgentIds() {
      const listing = this.ogListing && this.ogListing[0] ? this.ogListing[0] : {};
      return [listing.agent, listing.agent_2, listing.agent_3]
        .filter(value => value !== null && value !== undefined && value !== '')
        .map(String);
    },
    relatedAgentHeading() {
      const names = [this.agent, this.agent_2, this.agent_3]
        .filter(agent => agent && agent.first_name)
        .map(agent => `${agent.first_name} ${agent.last_name || ''}`.trim());
      return names.length ? names.join(', ') : 'THIS AGENT';
    },
    relatedPropertiesEndpoint() {
      return 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_rentals.php';
    },
    relatedPropertiesAreRentals() {
      return true;
    },
    setOGTags() {
      const existingOGTags = document.querySelectorAll('meta[property^="og:"]');
      existingOGTags.forEach(tag => tag.remove());
      const ogTags = [
        { property: 'og:title', content: this.listing.data.listing[0].marketing_heading },
        { property: 'og:description', content: this.listing.ai_description },
        // { property: 'og:image:secure_url', content: this.listing.featured_image },
        { property: 'og:url', content: this.currentUrl },
      ];
      ogTags.forEach(tag => {
        const metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        metaTag.setAttribute('content', tag.content);
        document.head.appendChild(metaTag);
      });
    },
    formattedLandSize() {
      const landSize = this.listing && this.listing.data && this.listing.data.listing ? this.listing.data.listing[0].land_size : 0;
      const squareMeters = Math.round(landSize * 10.764);
      return null;
    },
    filteredTags() {
      return Object.fromEntries(
        Object.entries(this.listing.tags || {}).filter(([key, value]) => value === true)
      );
    },
    formattedPrice() {
      const price = this.ogListing[0].price;
      return price.toLocaleString() + " per month";
    },
    formattedDescription() {
      const rawDescription = this.listing.ai_long_description;
      const sentences = rawDescription.split('. ');
      const paragraphs = [];
      for (let i = 0; i < sentences.length; i += 3) {
        const paragraph = sentences.slice(i, i + 3).join('. ');
        if (!paragraph.endsWith('.')) {
          paragraphs.push(paragraph + '.');
        } else {
          paragraphs.push(paragraph);
        }
      }
      return paragraphs;
    },
    currentUrl() {
      return encodeURIComponent(window.location.href)
    },
    facebookShareLink() {
      const text = encodeURIComponent(this.listing.data.listing[0].marketing_heading);
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    },
    linkedinShareLink() {
      const text = encodeURIComponent(this.listing.data.listing[0].marketing_heading);
      return `http://www.linkedin.com/shareArticle?mini=true&url=${this.currentUrl}&title=${text}&source=luxury.chaseveritt.co.za`
    },
    pinterestShareLink() {
      // console.log(this.listing.data.listing[0])
      const text = encodeURIComponent(this.listing.data.listing[0].marketing_heading);
      return `http://pinterest.com/pin/create/bookmarklet/?media=${this.listing.featured_image}&url=${this.currentUrl}]&is_video=false&description=${text}`
    },
    twitterShareLink() {
      const text = encodeURIComponent("Luxury property presented by Chas Everitt Luxury");
      return `https://twitter.com/intent/tweet?url=${this.currentUrl}&text=${text}`;
    },
  },
  methods: {

    normaliseRelatedListing(item, isRental = false) {
      if (!item || typeof item !== 'object') return null;

      const payloadListing = item.payload && item.payload.listing
        ? item.payload.listing
        : (item.listing || item);

      let listingData = payloadListing && payloadListing.data
        ? payloadListing.data.listing
        : null;

      if (Array.isArray(listingData)) {
        listingData = listingData[0];
      } else if (listingData && typeof listingData === 'object' && listingData[0]) {
        listingData = listingData[0];
      } else if (!listingData && payloadListing && payloadListing.id) {
        listingData = payloadListing;
      }

      if (!listingData || typeof listingData !== 'object') return null;

      const outerTags = payloadListing.tags || {};
      const innerTags = listingData.tags || {};
      const tags = Object.assign({}, innerTags, outerTags);
      const exclusion = typeof payloadListing.exclusion === 'string'
        ? payloadListing.exclusion.trim()
        : '';
      const status = String(listingData.status || '').toLowerCase();
      const images = Array.isArray(listingData.listing_images)
        ? listingData.listing_images
        : [];
      const hdImages = Array.isArray(listingData.listing_images_hd)
        ? listingData.listing_images_hd
        : [];
      const image = payloadListing.featured_image || images[0] || hdImages[0] || '';
      const id = String(listingData.id || item.ref_id || item.id || '');
      const rental = isRental || tags.rent === true || /to let|rent/i.test(String(listingData.listing_type || ''));

      if (!id || !image || exclusion !== '' || (status && status !== 'active')) return null;

      return {
        id,
        agentIds: [listingData.agent, listingData.agent_2, listingData.agent_3]
          .filter(value => value !== null && value !== undefined && value !== '')
          .map(String),
        image,
        heading: listingData.marketing_heading || listingData.property_title || listingData.property_type || 'Property',
        location: [listingData.loc_suburb, listingData.loc_region].filter(Boolean).join(', '),
        description: String(listingData.description || payloadListing.ai_description || '')
          .replace(/<[^>]*>/g, ' ')
          .replace(/\s+/g, ' ')
          .trim(),
        price: Number(listingData.price || 0),
        isRental: rental,
        url: rental ? '/rental/' + id : '/property/' + id
      };
    },
    async fetchRelatedProperties() {
      try {
        let rawListings = Array.isArray(this.originalListings)
          ? this.originalListings
          : [];

        // Fallback only if the normal page listings request did not return an array.
        if (!rawListings.length) {
          const response = await axios.get(this.relatedPropertiesEndpoint, {
            headers: { 'Accept': 'application/json' }
          });

          if (Array.isArray(response.data)) {
            rawListings = response.data;
          } else if (response.data && Array.isArray(response.data.listings)) {
            rawListings = response.data.listings;
          } else if (response.data && response.data.data && Array.isArray(response.data.data.listings)) {
            rawListings = response.data.data.listings;
          }
        }

        const currentId = String(this.$route.params.propertyId || '');
        const currentAgents = this.currentAgentIds;
        const seen = new Set();

        if (!currentAgents.length) {
          console.warn('No agent IDs found for related properties');
          this.relatedProperties = [];
          return;
        }

        this.relatedProperties = rawListings
          .map(item => this.normaliseRelatedListing(item, this.relatedPropertiesAreRentals))
          .filter(Boolean)
          .filter(property => property.id !== currentId)
          .filter(property => property.agentIds.some(agentId => currentAgents.includes(agentId)))
          .filter(property => {
            if (seen.has(property.id)) return false;
            seen.add(property.id);
            return true;
          })
          .slice(0, 3);

        console.log('Related agent properties:', {
          currentAgents,
          sourceCount: rawListings.length,
          matchedCount: this.relatedProperties.length
        });
      } catch (error) {
        console.error('Unable to load other agent properties:', error);
        this.relatedProperties = [];
      }
    },
    incrementLeads: async function () {
      try {
        const response = await axios.post('https://luxury-dev.chaseveritt.co.za/api/capture_lead.php', {
          ref_id: this.$route.params.propertyId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        });
        console.log("Leads updated successfully:", response.data);
      } catch (error) {
        console.error("Error updating leads:", error);
      }
    },
    incrementViews: async function () {
      try {
        const response = await axios.post('https://luxury-dev.chaseveritt.co.za/api/capture_view.php', {
          ref_id: this.$route.params.propertyId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        });
        console.log("Leads updated successfully:", response.data);
      } catch (error) {
        console.error("Error updating leads:", error);
      }
    },
    fetchListings: async function () {
      this.loading = true;
      try {
        const response = await axios.get('https://luxury-dev.chaseveritt.co.za/api/v3/fetch_listings.php', {
          headers: {
            'Accept': 'application/json',
          }
        });
        this.originalListings = response.data
        this.listings = this.originalListings
      } catch (error) {
        console.log(error)
      }
      this.listings = this.listings.filter(listing => {
        return listing.payload && listing.payload.listing && listing.payload.listing.exclusion === '';
      });
      
      this.loading = false
    },
    printToPDF() {
      window.print();
    },
    fetchListing: async function () {
      this.loading = true
      this.$store.state.agentMails = []
      try {
        const response = await axios.post('https://luxury-dev.chaseveritt.co.za/api/v3/fetch_fusion_rental.php', {
          id: this.$route.params.propertyId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        });
        this.ogListing = response.data.data.listing
      } catch (error) {
        console.log(error)
      }
      try {
        const response = await axios.post('https://luxury-dev.chaseveritt.co.za/api/v3/fetch_rental.php', {
          id: this.$route.params.propertyId
        }, {
          headers: {
            'Accept': 'application/json',
          }
        });
        this.listing = response.data.listing
      } catch (error) {
        console.log(error)
      }
      try {
        const agentResponse = await axios.post('https://luxury-dev.chaseveritt.co.za/api/v3/fetch_agent.php', {
          id: this.ogListing[0].agent
        }, {
          headers: {
            'Accept': 'application/json',
          }
        })
        this.agent = agentResponse.data.data.agent[0]
        this.$store.state.agentMails.push(this.agent.email_address)
      } catch (error) {
        console.log(error)
      }
      if (this.ogListing[0].agent_2 != null) {
        try {
          const agentResponse = await axios.post('https://luxury-dev.chaseveritt.co.za/api/v3/fetch_agent.php', {
            id: this.ogListing[0].agent_2
          }, {
            headers: {
              'Accept': 'application/json',
            }
          })
          this.agent_2 = agentResponse.data.data.agent[0]
          this.$store.state.agentMails.push(this.agent_2.email_address)
        } catch (error) {
          console.log(error)
        }
      }
      if (this.ogListing[0].agent_3 != null) {
        try {
          const agentResponse = await axios.post('https://luxury-dev.chaseveritt.co.za/api/v3/fetch_agent.php', {
            id: this.ogListing[0].agent_3
          }, {
            headers: {
              'Accept': 'application/json',
            }
          })
          this.agent_3 = agentResponse.data.data.agent[0]
          this.$store.state.agentMails.push(this.agent_3.email_address)
        } catch (error) {
          console.log(error)
        }
      }

      // Get the current URL
      let currentURL = window.location.href;
      let cleanedNumber = this.agent.cell_number.replace(/\D/g, '');
      let countryCode = '27';
      let formattedNumber = cleanedNumber.startsWith(countryCode) ? cleanedNumber : countryCode + cleanedNumber;
      this.whatsappLink = `https://wa.me/${formattedNumber}?text=Hello! I am interested in the property I found on your Portfolio website: ${currentURL}`;

      if (this.agent_2.cell_number) {
        cleanedNumber = this.agent_2.cell_number.replace(/\D/g, '');
        formattedNumber = cleanedNumber.startsWith(countryCode) ? cleanedNumber : countryCode + cleanedNumber;
        this.whatsappLink_2 = `https://wa.me/${formattedNumber}?text=Hello! I am interested in the property I found on your Portfolio website: ${currentURL}`;
      }

      if (this.agent_3.cell_number) {
        cleanedNumber = this.agent_3.cell_number.replace(/\D/g, '');
        formattedNumber = cleanedNumber.startsWith(countryCode) ? cleanedNumber : countryCode + cleanedNumber;
        this.whatsappLink_3 = `https://wa.me/${formattedNumber}?text=Hello! I am interested in the property I found on your Portfolio website: ${currentURL}`;
      }
      // assign a template to any that don't have
      if (!this.listing.template) {
        this.listing.template = 6
      }
      // assign dynamic values from the Lux API to the current property.
      this.loading = false
    },
    expandImage(index) {
      this.activeImageIndex = index
      this.isImageExpanded = true
      this.isImageClicked = true
    }
  }
};
</script>

<style scoped>
.force-height {
  height: 300px;
  object-fit: cover;
}
  .expanded {
    transform: scale(1.2);
    z-index: 1;
  }
  .social-links{
  position: unset;
  display: inline;
  float: right;
}
.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}
.fixed-enquire {
  position: fixed;
  top: 20%;
  right: 20px;
  z-index: 1000;
}
iframe {
  border-bottom-right-radius: 30px;
}
</style>

<style>

    .lightbox .lb-image { 
    border-color: #000;
    }
    .gallery-image {
        transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for transform and box-shadow */
    }

    .gallery-image:hover {
        transform: scale(1.05); /* Slightly enlarge the image */
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* Add a subtle shadow effect */
    }
/* Hide Featured Image 2 on tablet and mobile devices */
  @media (max-width: 1200px) {
    .featured-image-2 {
        display: none;
    }

    /* Ensure images are responsive and look good on small screens */
    @media (max-width: 1210px) {
    .zoomable-image {
        width: 100%; /* Make the image responsive and adjust to the screen width */
        height: auto; /* Allow the height to adjust automatically to the aspect ratio */
        object-fit: cover; /* Ensure images cover the container without distortion */
    }
    
    /* Adjust the layout for smaller screens (stack the columns) */
    .container-fluid {
        padding: 5px; /* Adjust padding to make it more compact on small screens */
        margin: 5px;
    }

    .row.g-0 {
        margin: 0;
        padding: 0;
    }

    .col-md-5 {
        width: 100%; /* Ensure columns take full width on small screens */
        padding: 5px; /* Reduced padding for better spacing */
    }

    /* Ensure image heights are not too large on small screens */
    .container-fluid img {
        max-height: 300px; /* Adjust image height on smaller screens */
        object-fit: cover;
    }

        @media (max-width: 991.98px) {
      td {
        width: 100% !important;
        padding: 5px !important;
      }

      td > div {
        flex-direction: column !important; /* Stack the images vertically */
        gap: 10px !important;              /* Optional: Add vertical spacing */
      }

      td > div > div {
        width: 100% !important;            /* Make each image container take full width */
      }

      td img.zoomable-image {
        width: 100% !important;
        height: auto !important;           /* Let height adapt to image ratio */
        object-fit: cover;
      }

      td button {
        height: auto !important;           /* Let button height adjust to image */
      }
    }

  } }

.featured-image-2 img {
    transition: transform 0.9s ease, box-shadow 0.9s ease;
}

.featured-image-2 img:hover {
    transform: scale(0.98); /* Zoom out slightly */
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}

/* Hover Effect for the Smaller Images */
.zoomable-image {
    transition: transform 0.9s ease, box-shadow 0.9s ease;
}

.zoomable-image:hover {
    transform: scale(0.98); /* Zoom out slightly */
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}

 .carousel-inner .carousel-item img {
  width: 100%;           /* Ensures the image takes the full width of the column */
  height: 300px;         /* You can adjust this value based on your desired image height */
  object-fit: cover;     /* Ensures the images maintain their aspect ratio while filling the container */
  object-position: center; /* Centers the image within the container */
}

.carousel-zoom img {
  transition: transform 0.9s ease;
}

.carousel-zoom:hover img {
  transform: scale(0.9);  /* Zoom effect on hover */
}

.force-height {
  height: 300px;
  object-fit: cover;
}
.expanded {
  transform: scale(1.2);
  z-index: 1;
}
.social-links{
  position: unset;
  display: inline;
  float: right;
}
.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}
.fixed-enquire {
  position: fixed;
  top: 20%;
  right: 20px;
  z-index: 1000;
}
iframe {
  border-bottom-right-radius: 30px;
}
/* Full height bottom offcanvas */
.offcanvas.offcanvas-bottom {
  height: 100vh; /* 100% of the viewport height */
  max-height: 100vh; /* Prevent the offcanvas from exceeding the screen height */
  top: 0; /* Ensure it starts from the bottom of the screen */
}

.offcanvas-body {
  padding-top: 20px; /* Optional: Add some padding to the body */
}
 .photo-album {
        margin: 0; /* Remove margin around the album */
        padding: 0; /* No padding around the album */
    }

    .photo-row {
        display: flex;
        justify-content: space-between;
        margin: 0; /* Remove margin between rows */
        padding: 0; /* No padding between rows */
    }

    .photo-item {
        width: 48%; /* Adjust width for large images */
        padding: 2px; /* 1px padding around images */
    }

    .photo-item img {
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 8px;
        padding: 2px; /* 1px padding around images */
        box-sizing: border-box; /* Ensures padding is included in width/height calculation */
    }

    /* For large images (take up more space) */
    .photo-row.large .photo-item {
        width: 100%; /* Large images take full width */
    }

    .photo-row.large .photo-item img {
        height: 470px; /* Fixed height for large images */
    }

    /* For smaller images (3 per row) */
    .photo-row.small .photo-item {
        width: 40%; /* 3 images per row */
    }

    .photo-row.small .photo-item img {
        height: 230px; /* Fixed height for smaller images */
    }
    

    
    /* FROM HERE DOWN IT IS CCS FOR Offcanvas Gall */

      /* Mobile and Tablet View (under 1200px) */
      @media (max-width: 1200px) {
      /* Gallery images will be full width on mobile and tablet devices */
      td.gallery-thumbnails > div {
        width: 100%; /* Each image takes full width */
        margin-bottom: 15px; /* Space between images */
      }

      td.gallery-thumbnails img {
        width: 100%; /* Image takes full width of the container */
        height: auto; /* Maintain aspect ratio */
        object-fit: cover; /* Ensure images fill the container without distortion */
      }

      /* When the Featured Image is Hidden (max-width: 1200px) */
      /* Add left padding to the image column when the featured image is hidden */
      td:not(.featured-image-2) {
        padding-left: 12px !important; /* Match the left padding of the featured image */
      }  

          
       @media (max-width: 950px) {
      /* General container setup */
      .photo-album {
        padding: 10px; /* Optional padding around the gallery */
      }

      /* Set photo-row to behave like a flex container */
      .photo-row {
        display: flex;
        flex-direction: column; /* Stack images vertically */
        margin: 0;
      }

      /* Each photo-item takes 100% width (one image per row) */
      .photo-item {
        width: 100% !important;
        padding: 0 !important; /* Remove extra padding */
        margin-bottom: 15px !important; /* Add space between rows */
        box-sizing: border-box; /* Prevent overflow issues */
      }

      /* Image styling: Ensure each image fits properly */
      .photo-item img {
        width: 100% !important; /* Take full width of the parent container */
        height: 400px !important; /* Fixed height for consistency */
        object-fit: cover; /* Ensure the image is cropped but maintains aspect ratio */
        display: block;
        border-radius: 0 !important; /* Remove rounded corners */
        padding: 0 !important; /* Remove extra padding */
      }
    }

/* HERE DOWN Its CCS FOR carousel*/
    @media (max-width: 768px) {
  .carousel-inner .carousel-item img {
    height: 200px;          /* Smaller height for mobile view */
    margin: 10px 0;         /* Adds vertical spacing */
  }

  .carousel-zoom img {
    transform: none !important; /* Disable zoom on small screens */
  }

  .carousel-zoom:hover img {
    transform: none !important; /* Ensure no hover zoom effect on touch devices */
  }
}
        

}
    


/* Other properties from the current property's agent(s) */
.agent-related-properties {
  background: #f5f5f5;
  margin-top: 60px;
}
.agent-related-card {
  background: #ececec;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.agent-related-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}
.agent-related-image-link {
  display: block;
  color: inherit;
  text-decoration: none;
}
.agent-related-image-wrap {
  position: relative;
  overflow: hidden;
}
.agent-related-image {
  width: 100%;
  height: 300px;
  display: block;
  object-fit: cover;
  transition: transform 0.35s ease;
}
.agent-related-card:hover .agent-related-image {
  transform: scale(1.03);
}
.agent-related-price-badge {
  position: absolute;
  top: 0;
  left: 18px;
  z-index: 2;
  padding: 12px 18px;
  background: #fff;
  color: #255699;
  border-radius: 0 0 18px 18px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.agent-related-status-badge {
  position: absolute;
  right: 12px;
  bottom: 0;
  z-index: 2;
  padding: 9px 14px;
  background: #153965;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.03em;
  border-radius: 8px 8px 0 0;
}
.agent-related-content {
  padding: 18px 16px 20px;
}
.agent-related-title {
  color: #255699;
  font-size: 21px;
  line-height: 1.05;
  font-weight: 700;
  text-transform: uppercase;
}
.agent-related-location {
  color: #255699;
  font-size: 13px;
}
.agent-related-location i {
  margin-right: 4px;
}
.agent-related-description {
  color: #111;
  font-size: 14px;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
@media (max-width: 767.98px) {
  .agent-related-image {
    height: 240px;
  }
  .agent-related-price-badge {
    left: 12px;
    padding: 11px 14px;
    font-size: 14px;
  }
}

</style>